import {Dimensions, Platform, StyleSheet}   from "react-native";
import Constants                            from "expo-constants";

const { height: winHeight, width: winWidth } = Dimensions.get("window");

export default StyleSheet.create({
    background: {
        height:             "100%", 
        width:              "100%"
    },
    backgroundClues: {
        borderColor:        "darkgray",
        borderWidth:        10,
        height:             "100%",
        width:              "100%"
    },
    backgroundCredits: {
        backgroundColor:    "black",
        height:             "100%",
        width:              "100%"
    },
    backgroundImageScreen: {
        resizeMode:         "cover"
    },
    backgroundImageStretch: {
        resizeMode:         "stretch"
    },
    backgroundModal: {
        height:             "100%",
        justifyContent:     "center",
        width:              "100%"
    },
    button: {
        backgroundColor:    "yellow",
        borderColor:        "black",
        borderRadius:       12,
        borderWidth:        1,
        color:              "black",
        fontWeight:         "bold",
        overflow:           "hidden",
        padding:            8,
        textAlign:          "center"
    },
    buttonIcon: {
        color:              "black"
    },
    buttonText: {
        color:              "black"
    },
    camera: {
        bottom:             0,
        flex:               1,
        height:             winHeight,
        justifyContent:     "space-between",
        left:               0,
        position:           "absolute",
        right:              0,
        top:                0,
        width:              winWidth
    },
    cameraAutoFocusLabel: {
        fontSize:           20,
        fontWeight:         "bold"
    },
    cameraBottomBar: {
        alignSelf:          "flex-end",
        backgroundColor:    "transparent",
        flex:               0.12,
        flexDirection:      "row",
        justifyContent:     "space-around",
        paddingBottom:      5
    },
    cameraBottomButton: {
        alignItems:         "center",
        flex:               0.3,
        height:             58,
        justifyContent:     "center"
    },
    // cameraContainer: {
    //     flex:               1,
    //     backgroundColor:    "#000"
    // },
    // cameraNoPermissions: {
    //     flex: 1,
    //     alignItems:'center',
    //     justifyContent: 'center',
    //     padding: 10,
    // },
    cameraPhotoButton: {
        alignSelf:          "center"
    },
    cameraToggleButton: {
        alignItems:         "center",
        flex:               0.25,
        height:             40,
        justifyContent:     "center",
        marginBottom:       10,
        marginHorizontal:   2,
        marginTop:          20,
        padding:            5
    },
    cameraTopBar: {
        backgroundColor:    "transparent",
        flex:               0.2,
        flexDirection:      "row",
        justifyContent:     "space-around",
        paddingTop:         Constants.statusBarHeight / 2
    },
    container: {
        backgroundColor:    "#fff",
        flex:               1
    },
    dropdown: {
        textAlign:          "center"
    },
    dropdownWeb: {
        textAlign:          "center",
        width:              "100%"
    },
    dropdownContainer: {
        backgroundColor:    "white",
        borderColor:        "black",
        borderWidth:        1,
        height:             50,
        justifyContent:     "center",
        width:              "100%"
    },
    dropdownInput: {
        alignItems:         "center",
        borderBottomColor:  "transparent"
    },
    dropdownItemText: {
        textAlign:          "center"
    },
    dropdownPicker: {
        width:              400
    },
    gestureStyle: {
        // flex:               1
    },
    lineHorizontal: {
        borderBottomColor:  "black",
        borderBottomWidth:  3
    },
    lineHorizontalModal: {
        alignSelf:          "center",
        borderBottomColor:  "white",
        borderBottomWidth:  3,
        width:              "90%"
    },
    lineVertical: {
        borderEndColor:     "black",
        borderEndWidth:     3
    },
    menu: { 
        alignSelf:          "center", 
        bottom:             0,
        height:             "40%",
        position:           "absolute",
        width:              "50%"
    },
    menuHorz: {
        alignSelf:          "center",
        flexDirection:      "row", 
        justifyContent:     "space-evenly",
        width:              "100%"
    },
    menuVert: {
        alignSelf:          "center",
        height:             "100%",
        justifyContent:     "space-evenly",
        width:              "75%"
    },
    modalBackground: {
        alignItems:         "center",
        backgroundColor:    "rgba(0, 0, 0, 0.5)",
        flex:               1,
        justifyContent:     "center"
    },
    modalButtonPanel: {
        alignSelf:          "center",
        padding:            5
    },
    modalDetailRow: {
        alignItems:         "center",
        flexDirection:      "row",
        justifyContent:     "space-evenly"
    },
    modalDetailText: {
        color:              "white",
        marginBottom:       5,
        marginTop:          5,
        textAlign:          "center",
        width:              "50%"
    },
    modalDialog: {
        alignSelf:          "center",
        height:             "65%",
        justifyContent:     "center",
        width:              "50%"
    },
    modalDialogInner: {
        height:             "95%",
        justifyContent:     "space-evenly",
        paddingLeft:        Platform.OS === "web" ? 20 : 5,
        paddingRight:       Platform.OS === "web" ? 20 : 5,
        paddingTop:         Platform.OS === "web" ? 50 : 25
    },
    modalDialogLarge: {
        alignSelf:          "center",
        height:             Platform.OS === "ios" ? "70%" : "75%",
        justifyContent:     "center",
        width:              "50%"
    },
    photoPreview: {
        alignSelf:          "center",
        height:             "70%",
        width:              "90%"
    },
    player: {
        alignItems:         "center",
        justifyContent:     "center"
    },
    playerIcon: {
        borderColor:        "yellow",
        borderRadius:       25,
        borderWidth:        4,
        height:             50,
        width:              50
    },
    playerIconSelected: {
        borderColor:        "transparent",
        borderRadius:       25,
        borderWidth:        4,
        height:             50,
        width:              50
    },
    textInput: {
        backgroundColor:    "white",
        borderColor:        "black",
        borderRadius:       12,
        borderWidth:        1,
        marginBottom:       1,
        marginTop:          1,
        overflow:           "hidden",
        padding:            Platform.OS === "ios" ? 8 : 0,
        textAlign:          "center",
        width:              "50%"
    },
    textModal: {
        color:              "white",
        textAlign:          "center"
    },
    textSetting: {
        fontSize:           18
    },
    textTitle: {
        color:              "black",
        // fontFamily:         "Optima",
        fontSize:           32,
        fontWeight:         "bold"
    },
    textTitleCredits: {
        color:              "white",
        fontSize:           32,
        fontWeight:         "bold",
        textAlign:          "center"
    },
    textTransparent: {
        color:              "transparent"
    },
    textWhite: {
        color:              "white",
        textAlign:          "center"
    },
    viewCategoryDisplay: {
        alignItems:         "center",
        alignSelf:          "center",
        height:             "100%",
        justifyContent:     "space-evenly",
        width:              "80%"
    },
    viewCategoryDropdown: {
        width:              "30%"
    },
    viewClueDisplay: {
        alignItems:         "center",
        height:             "100%",
        justifyContent:     "center",
        width:              "100%"
    },
    viewClueDisplayBackground: {
        alignSelf:          "center",
        height:             "90%",
        width:              "50%"
    },
    viewCreditDisplay: {
        alignItems:         "center",
        height:             "100%",
        justifyContent:     "center",
        width:              "33%"
    },
    viewCreditsLayout: {
        alignSelf:          "center",
        flexDirection:      "column",
        height:             "100%",
        justifyContent:     "space-around",
        padding:            20,
        width:              "100%"
    },
    viewCreditsRow: {
        alignSelf:          "center",
        flex:               1,
        flexDirection:      "row",
        justifyContent:     "space-around",
        width:              "100%"
    },
    viewGameControls: {
        alignItems:         "center",
        height:             "100%",
        justifyContent:     "space-evenly",
        width:              "20%"
    },
    viewGameDisplay: {
        flexDirection:      "row",
        height:             "70%",
        justifyContent:     "space-evenly",
        width:              "100%"
    },
    viewGuessControls: {
        alignItems:         "center",
        height:             "100%",
        justifyContent:     "center",
        width:              "20%"
    },
    viewHowToPlay: {
        height:             "60%",
        justifyContent:     "space-evenly",
        padding:            10
    },
    viewPadded: {
        padding:            5
    },
    viewPlayer: {
        width:              "20%"
    },
    viewPlayerDisplay: {
        alignSelf:          "center",
        flexDirection:      "row",
        height:             "30%",
        justifyContent:     "space-around",
        width:              "100%"
    },
    viewPointsParent: {
        flexDirection:      "row",
        height:             "100%",
        justifyContent:     "space-between",
        padding:            5,
        width:              "100%"
    },
    viewPointsPlayer: {
        alignSelf:          "center",
        justifyContent:     "center"
    },
    viewPointsPlayerColumn: {
        height:             "100%",
        justifyContent:     "space-between"
    },
    viewSettingsDisplay: {
        alignItems:         "center",
        height:             "55%",
        justifyContent:     "space-between",
        width:              "40%"
    },
    viewSettingsDisplayPlayers: {
        height:             "100%",
        marginBottom:       10,
        width:              "100%"
    },
    viewSettingsScreen: {
        alignItems:         "center",
        height:             "100%"
    },
    viewSettingsRow: {
        alignItems:         "center",
        flexDirection:      "row",
        justifyContent:     "space-between",
        marginBottom:       3,
        width:              Platform.OS === "web" ? "80%" : "100%"
    },
    viewSettingsRowWeb: {
        alignItems:         "center",
        flexDirection:      "row",
        justifyContent:     "center",
        marginBottom:       10,
        marginTop:          10,
        width:              "100%"
    },
    viewSubcategoryDisplay: {
        alignItems:         "center",
        alignSelf:          "center",
        flexDirection:      "row",
        height:             "40%",
        justifyContent:     "space-evenly",
        width:              "100%"
    },
    viewSubcategoryPoster: {
        alignItems:         "center",
        height:             "100%",
        justifyContent:     "center",
        width:              "100%"
    },
    viewSubcategoryPosterBackground: {
        alignItems:         "center",
        height:             "100%",
        justifyContent:     "center",
        width:              "20%"
    }
});